import { FileText } from 'lucide-react';
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/v2/ui';

interface MenuGroupItem {
  id: string;
  name: string;
}

interface AIFieldMenuGroupProps {
  label: string;
  items: MenuGroupItem[];
  onPick: (id: string) => void;
}

/** Reusable separated dropdown group (Haus-Vorlagen / Meine Vorlagen). */
export function AIFieldMenuGroup({ label, items, onPick }: AIFieldMenuGroupProps) {
  if (items.length === 0) return null;
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>{label}</DropdownMenuLabel>
      {items.map((item) => (
        <DropdownMenuItem key={item.id} onClick={() => onPick(item.id)}>
          <FileText className="h-4 w-4 mr-2" />
          {item.name}
        </DropdownMenuItem>
      ))}
    </>
  );
}
